import {NavigationType} from '../types/block';
import {LocaleEnum, localeToLocaleAlias} from '../types/locale';
import {DatoException} from '../utils/exception/DatoException';
import {IntlShape} from 'react-intl/src/types';
import {graphql, useStaticQuery} from 'gatsby';

export function useGetNavItems(intl: IntlShape): Array<NavigationType> {
  const data = useStaticQuery(graphql`
    fragment Navigation on DatoCmsNavigation {
      id
      originalId
      title
      bg {
        hex
      }
      textColor {
        hex
      }
      actionTextColor {
        hex
      }
      slug {
        slug
      }
      submenu {
        title
        isNew
        description
        icon
        slug {
          ... on DatoCmsBlogpost {
            slug
            model {
              name
            }
          }
          ... on DatoCmsPage {
            slug
            model {
              name
            }
          }
        }
        customSlug
      }
      locales
    }

    query GetNavigation {
      deAT: allDatoCmsNavigation(sort: {id: ASC}, filter: {locales: {eq: "de-AT"}}, locale: "de-AT") {
        nodes {
          ...Navigation
        }
      }
      deDE: allDatoCmsNavigation(sort: {id: ASC}, filter: {locales: {eq: "de-DE"}}, locale: "de-DE") {
        nodes {
          ...Navigation
        }
      }
      deCH: allDatoCmsNavigation(sort: {id: ASC}, filter: {locales: {eq: "de-CH"}}, locale: "de-CH") {
        nodes {
          ...Navigation
        }
      }
      enIE: allDatoCmsNavigation(sort: {id: ASC}, filter: {locales: {eq: "en-IE"}}, locale: "en-IE") {
        nodes {
          ...Navigation
        }
      }
      enUS: allDatoCmsNavigation(sort: {id: ASC}, filter: {locales: {eq: "en-US"}}, locale: "en-US") {
        nodes {
          ...Navigation
        }
      }
    }
  `);

  const localeAlias = localeToLocaleAlias(intl.locale as LocaleEnum);
  const localeNav = data[localeAlias] ? data[localeAlias].nodes : [];

  // All or nothing for style fields
  const styleFields = ['textColor', 'bg', 'actionTextColor'];
  const invalidItem = localeNav.find(item => {
    let foundNonNullField = false,
      foundNullField = false;

    styleFields.forEach(field => {
      if (item[field] === null) {
        foundNullField = true;
      } else {
        foundNonNullField = true;
      }
    });

    // There's at least 1 field with data and at least 1 other with no data (all or nothing)
    return foundNonNullField && foundNullField;
  });

  if (invalidItem) {
    throw new DatoException(`Navigation item ${invalidItem.title} must have all Style fields filled out`, invalidItem.id, data.originalId);
  }

  return localeNav;
}
